import React from "react";
import Box from "@mui/material/Box";
import { Container, Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionSummaryHead from "./components/AccordionSummaryHead";
import DropdownBox from "./components/DropdownBox";
import PickUpandDeliveryLocations from "./components/PickUpandDeliveryLocations/";
import PackageOptionsandDetails from "./components/PackageOptionsandDetails/";
import Tags from "./components/Tags/"
import DeliveryTime from "./components/DeliveryTime/";
import Review from "./components/Review/";
import Finalview from "./components/Finalview/";
import CustomDialog from "./components/dialog/Dialog";
import Copyright from "../Copyright";
import JSPM from "jsprintmanager";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import {pad2} from "./components/helperFunctions/index.js";
import "./NewOrder.css";
import "animate.css/animate.css";
import "react-circular-progressbar/dist/styles.css";
import CountdownTimer from "./components/CountdownTimer.js";
import TagsSummary from "./components/TagsSummary.js";
import httpRequest from "../HttpService.js";
import WarningIcon from '@mui/icons-material/Warning';
import { useParams } from "react-router-dom";


const accordionStructure= {
  1: {title: "Pick Up and Delivery Locations",},
  2: {title: "Shipment Description",},
  3: {title: "Tags",},
  4: {title: "Delivery Time",},
  5: {title: "Review",},
  6: {title: "Order Number and Print Label",}
}

const accordionNum = Object.keys(accordionStructure).length;

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px 0px 1px 0px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderTop: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({}));

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


class NewOrder extends React.Component {
constructor(props) {
    super(props);
    this.state = {
      expanded: 0,
      info: Array.from({length:accordionNum+1}, () => new Object()),
      alert: Array.from({length:accordionNum+1}, () => new Set().add("Initial")),
      completed: new Map(Array.from({length:accordionNum}, (_,i) => [i+1, false])),
      accountNumber: this.props.account? this.props.account : localStorage.getItem("accountNumber"),
      accountList: this.props.accountList,
      props: [],
      openHideDialog: false,
      openChangePickupDialog: false,
      openRequiredFieldDialog: false,
      countTimerStatus:0,
      duration: -1,
      durationText: "",
      intervalId: 0,
      isEmbedded: this.props.isEmbedded,
      isLoadingQuote: false,
      loadedQuoteId: null
    };
  }

  getInfo = () => {
    return this.state.info;
  }

  getFirstIncompleteStep = (completed) => {
    for (let i = 1; i <= 6; i++) {
        if (!completed.get(i)) {
            return i;
        }
    }
    return null; // All steps are complete
};

  componentDidMount = () => {
    const { quoteID } = this.props.params;

    if (this.state.accountNumber === null || this.state.accountNumber === "")
      window.location.href = "/";

     if (quoteID) {
      this.setState({ isLoadingQuote: true });
      this.loadQuote(quoteID);
    }

    this.setState({ accountList: this.props.accountList });
    this.setState({ props: [{}, {
      "component": PickUpandDeliveryLocations,
      "props": {
        "info": this.state.info,
      }
    }, {
      "component": PackageOptionsandDetails,
      "props": {
        "info": this.state.info,
      }
    }, {
      "component": Tags,
      "props": {
        "info": this.state.info,
      }
    }, {
      "component": DeliveryTime,
      "props": {
        "info": this.state.info,
      }
    }, {
      "component": Review,
      "props": {
        "info": this.state.info,
        "newOrderPanel": this.newOrderPanel,
      }
    }, {
      "component": Finalview,
      "props": {
        "info": this.state.info,
        "newOrderPanel": this.newOrderPanel,
        "accountNumber":this.state.accountNumber,
      }
    }] });

    this.getAccountNotes();
  };

loadQuote = (quoteID) => {
    console.log(`
🔥🔥🔥 LOADQUOTE START - ID: ${quoteID} 🔥🔥🔥`);
    console.log(`🔴 WebX loadQuote - Current state.accountNumber: ${this.state.accountNumber}`);
    console.log(`🔴 WebX loadQuote - localStorage accountNumber: ${localStorage.getItem('accountNumber')}`);
    console.log(`🔴 WebX loadQuote - localStorage sso_token: ${localStorage.getItem('sso_token')}`);

    // CRITICAL: Set loadedQuoteId IMMEDIATELY to prevent componentDidUpdate from overriding account changes
    this.setState({ isLoadingQuote: true, loadedQuoteId: quoteID });
    // STEP 1: Get the quote data first to know which account it belongs to
    httpRequest.postQuoteInfo(null, null, null, quoteID)
      .then(async response => {
        console.log(`
📦 QUOTE API RESPONSE:`, JSON.stringify(response.data[0], null, 2));
        console.log(`🟢 Quote data account: ${response.data[0].account}`);
        console.log(`🔴 Current state account: ${this.state.accountNumber}`);

        const quoteData = response.data[0];
        if (!quoteData) {
          console.error("❌ Quote not found:", quoteID);
          this.setState({ isLoadingQuote: false });
          return;
        }

        // STEP 2: Check if we need to switch accounts
        const quoteAccount = quoteData.account;
        const currentAccount = this.state.accountNumber;

        if (quoteAccount !== currentAccount) {
          console.log(`
🔄 ACCOUNT SWITCH REQUIRED:
From: ${currentAccount}
To: ${quoteAccount}
Calling getAccountDetail to properly switch accounts and reload group...`);

          // CRITICAL: Call getAccountDetail to properly switch accounts
          // This calls the /login endpoint which returns user info for the new account
          try {
            const accountDetailResponse = await httpRequest.getAccountDetail(quoteAccount);
            console.log(`✅ getAccountDetail response:`, accountDetailResponse.data);

            const newAccountUser = accountDetailResponse.data.user;
            const newGroupID = newAccountUser?.groupID;

            console.log(`🔍 Parsed groupID from response: "${newGroupID}" (type: ${typeof newGroupID})`);

            // Update global state and localStorage with new account info
            localStorage.setItem('accountNumber', quoteAccount);

            // Update the global user context
            if (this.props.updateGlobalAccount) {
              this.props.updateGlobalAccount(quoteAccount);
            }

            // IMPORTANT: Reload the account list for the new group
            // This ensures the dropdown shows the correct accounts for the new group
            // Check for valid groupID (not null, not undefined, not empty string, and not 0 unless explicitly allowed)
            if (newGroupID !== null && newGroupID !== undefined && newGroupID !== '') {
              console.log(`🔄 Loading accounts for group ${newGroupID}...`);
              try {
                const groupAccountsResponse = await httpRequest.getGroupAccounts(newGroupID);
                console.log(`✅ Loaded new group accounts:`, groupAccountsResponse.data);

                // Validate the response has data
                if (groupAccountsResponse.data && Array.isArray(groupAccountsResponse.data) && groupAccountsResponse.data.length > 0) {
                  // Format the accounts for the dropdown
                  const newAccountList = groupAccountsResponse.data.map((person, i) => {
                    return {id: i, value: person.account, label: person.accountName};
                  });

                  // Update both accountList AND accountNumber together to avoid timing issues
                  this.setState({
                    accountList: newAccountList,
                    accountNumber: quoteAccount
                  });

                  console.log(`✅ Updated accountList with ${newAccountList.length} accounts from new group, set accountNumber to ${quoteAccount}`);
                } else {
                  console.warn(`⚠️ getGroupAccounts returned empty or invalid data, falling back to single account`);
                  this.setState({
                    accountList: [{id: 1, value: quoteAccount, label: quoteAccount}],
                    accountNumber: quoteAccount
                  });
                }
              } catch (groupError) {
                console.error(`❌ Failed to load group accounts for groupID ${newGroupID}:`, groupError);
                // Fallback to single account on error
                this.setState({
                  accountList: [{id: 1, value: quoteAccount, label: quoteAccount}],
                  accountNumber: quoteAccount
                });
              }
            } else {
              console.log(`ℹ️ No groupID found (value: "${newGroupID}"), using single account`);
              // No group - single account
              this.setState({
                accountList: [{id: 1, value: quoteAccount, label: quoteAccount}],
                accountNumber: quoteAccount
              });
            }

            console.log(`✅ Account switch complete:
New Account: ${quoteAccount}
New GroupID: ${newGroupID}`);
          } catch (accountDetailError) {
            console.error(`❌ Failed to get account detail for ${quoteAccount}:`, accountDetailError);
            // Still try to continue with the quote load, but with limited account info
            localStorage.setItem('accountNumber', quoteAccount);
            if (this.props.updateGlobalAccount) {
              this.props.updateGlobalAccount(quoteAccount);
            }
            this.setState({
              accountList: [{id: 1, value: quoteAccount, label: quoteAccount}]
            });
          }
        } else {
          console.log(`✓ Already on correct account: ${quoteAccount}`);
        }
  
        const info = this.state.info;
        const alert = this.state.alert;
        const completed = this.state.completed;

        console.log(`
🔥 BEFORE LOADING - Alert State:
Step 0: ${Array.from(alert[0])}
Step 1: ${Array.from(alert[1])}
Step 2: ${Array.from(alert[2])}`);

        // Populate quote data (preselected but not completed)
        info[0].quoteId = quoteData.quoteID;
        info[0].caller = quoteData.caller;
        info[0].accountId = quoteData.account; // Set the account from the quote

        // Load saved custom pickup/delivery times from the quote so the
        // Step 4 radios open to "Yes" with the saved date already shown.
        // The backend stores these as ISO timestamps in customDTPickupStart
        // ("Pick Up in Future?") and customDTDeliveryEnd ("Specify Delivery
        // By Time?") — same fields posted by postQuoteCustomTime.
        const pickupStartIso = quoteData.customDTPickupStart || null;
        const deliveryEndIso = quoteData.customDTDeliveryEnd || null;
        const savedPickupStart = pickupStartIso ? new Date(pickupStartIso) : null;
        const savedDeliveryEnd = deliveryEndIso ? new Date(deliveryEndIso) : null;
        if (savedPickupStart || savedDeliveryEnd) {
          info[4] = {
            ...info[4],
            readyAtDate: savedPickupStart || info[4]?.readyAtDate || null,
            readyAtDateChecked: !!savedPickupStart,
            deliveryTime: savedDeliveryEnd || info[4]?.deliveryTime || null,
            deliveryTimeChecked: !!savedDeliveryEnd,
          };
          console.log(`
📅 CUSTOM DELIVERY TIMES LOADED FROM QUOTE:
customDTPickupStart: ${pickupStartIso || 'none'}
customDTDeliveryEnd: ${deliveryEndIso || 'none'}`);
        }

        console.log(`
🔵 QUOTE ACCOUNT SET:
Quote Account: ${quoteData.account}
Current State Account: ${this.state.accountNumber}
Setting info[0].accountId to: ${info[0].accountId}`);

        // Clear caller alert since we have it from the quote
        alert[0].delete("caller");
        alert[0].delete("Initial");
        
        // Store pieces/weight from postQuoteInfo (these are correct)
        const quotePieces = quoteData.pieces;
        const quoteWeight = quoteData.weight;
        
        console.log(`
📊 PIECES/WEIGHT from postQuoteInfo:
Pieces: ${quotePieces}
Weight: ${quoteWeight}`);
        
        // Fetch and preselect address details (but don't mark as complete)
        // IMPORTANT: Use the quote's account, not the current state account
        const shipperRes = await httpRequest.getAddressByID(quoteAccount, quoteData.shipAddressID);
        const consigneeRes = await httpRequest.getAddressByID(quoteAccount, quoteData.conAddressID);
        
        info[1].pickUpLocation = shipperRes.data[0];
        info[1].deliveryLocation = consigneeRes.data[0];

        console.log(`
🏠 ADDRESSES LOADED:
Shipper: ${info[1].pickUpLocation?.companyName} (ID: ${info[1].pickUpLocation?.addressID})
Consignee: ${info[1].deliveryLocation?.companyName} (ID: ${info[1].deliveryLocation?.addressID})`);

        // Clear address alerts since we have them from the quote
        alert[1].delete("pickUpLocation");
        alert[1].delete("deliveryLocation");
        alert[1].clear(); // Clear ALL step 1 alerts
        
        // Fetch package descriptions to get the package type name
        const descriptionsRes = await httpRequest.getQuoteDescriptions(quoteData.quoteID);
        
        // Find the package type using descriptionID if available, otherwise guess by weight
        let selectedPackageType = null;
        if (descriptionsRes.data && descriptionsRes.data.length > 0) {
          const availablePackages = descriptionsRes.data;
          
          // NEW: Use descriptionID if backend provides it
          if (quoteData.descriptionID) {
            console.log(`🎯 Using descriptionID: ${quoteData.descriptionID}`);
            const matchedPackage = availablePackages.find(pkg => pkg.descriptionID === quoteData.descriptionID);
            selectedPackageType = matchedPackage ? matchedPackage.iconTitleText : null;
            
            console.log(`🔍 PACKAGE TYPE LOOKUP:
DescriptionID: ${quoteData.descriptionID}
Matched Package: ${selectedPackageType || 'NOT FOUND'}`);
          }
          
          // FALLBACK: If no descriptionID or no match found, try weight-based detection
          if (!selectedPackageType) {
            console.log(`⚠️ No descriptionID found, falling back to weight-based detection`);
            
            for (const pkg of availablePackages) {
              if (pkg.validateMinWeight && pkg.validateMaxWeight) {
                if (quoteWeight >= pkg.validateMinWeight && quoteWeight <= pkg.validateMaxWeight) {
                  selectedPackageType = pkg.iconTitleText;
                  break;
                }
              } else if (pkg.validateMaxWeight && quoteWeight <= pkg.validateMaxWeight) {
                selectedPackageType = pkg.iconTitleText;
                break;
              }
            }
            
            // If no match found, default to the last available package
            if (!selectedPackageType && availablePackages.length > 0) {
              selectedPackageType = availablePackages[availablePackages.length - 1].iconTitleText;
            }
            
            console.log(`🔍 WEIGHT-BASED DETECTION:
Weight: ${quoteWeight}
Detected Package: ${selectedPackageType}`);
          }
          
          if (selectedPackageType) {
            // Parse piecesJSON if available
            let parsedPiecesJSON = null;
            if (quoteData.piecesJSON) {
              try {
                const rawPieces = JSON.parse(quoteData.piecesJSON);
                // Add id field to each piece if it doesn't exist
                parsedPiecesJSON = rawPieces.map((piece, index) => ({
                  id: piece.id || index + 1,
                  ...piece
                }));
                console.log(`📦 Parsed piecesJSON with IDs:`, parsedPiecesJSON);
              } catch (e) {
                console.error("Error parsing piecesJSON from quote:", e);
              }
            }

            info[2] = {
                ...info[2],
                packageSize: selectedPackageType,
                pieces: quotePieces,  // Use correct values from postQuoteInfo
                weight: quoteWeight,  // Use correct values from postQuoteInfo
                overrideBillWeight: quoteData.overrideBillWeight || quoteData.override_bill_weight || '',
                additionalDescription: quoteData.del_inst || "",
                piecesJSON: quoteData.piecesJSON || null,
                defineIndividual: parsedPiecesJSON || [],
                quoteDescriptions_data: {
                    pieces: quotePieces,
                    weight: quoteWeight,
                    overrideBillWeight: quoteData.overrideBillWeight || quoteData.override_bill_weight || '',
                    piecesJSON: quoteData.piecesJSON || null
                }
            };

            console.log(`
📦 PACKAGE DATA SET:
Package: ${info[2].packageSize}
Pieces: ${info[2].pieces}
Weight: ${info[2].weight}
Override Bill Weight: ${info[2].overrideBillWeight || 'None'}
PiecesJSON: ${info[2].piecesJSON ? 'YES (' + (parsedPiecesJSON?.length || 0) + ' items)' : 'None'}
Method: ${quoteData.descriptionID ? 'descriptionID lookup' : 'weight-based guess'}`);
          }
        }

        console.log(`
🔥 AFTER LOADING - Alert State:
Step 0: ${Array.from(alert[0])}
Step 1: ${Array.from(alert[1])}
Step 2: ${Array.from(alert[2])}`);

        // DO NOT mark any steps as completed - user must click Next on each step
        // DO NOT clear any step alerts - user must validate each step

        // Always start at step 1, regardless of preselected data
        // IMPORTANT: Set accountNumber FIRST, then info
        // This ensures the account is switched BEFORE the DropdownBox tries to sync
        // Note: loadedQuoteId is already set at the beginning of loadQuote
        this.setState({
          accountNumber: quoteData.account, // Switch to quote's account FIRST
          isLoadingQuote: false,
        }, () => {
          // Update the global account state if the callback is provided
          if (this.props.updateGlobalAccount) {
            this.props.updateGlobalAccount(quoteData.account);
          }

          // Update account notes for the new account
          this.getAccountNotes();

          // Now set the info data - DropdownBox will handle setting info[0].accountId
          this.setState({
            info: info,
            alert: alert,
            completed: completed, // Keep original completion state (all false)
            expanded: 1, // ALWAYS start at step 1
          }, () => {
            console.log(`
✅ LOADQUOTE COMPLETE - Final State:
AccountNumber: ${this.state.accountNumber}
Info[0]: quoteId=${info[0].quoteId}, caller=${info[0].caller}, accountId=${info[0].accountId}
Info[1]: pickup=${!!info[1].pickUpLocation}, delivery=${!!info[1].deliveryLocation}
Info[2]: package=${info[2].packageSize}, pieces=${info[2].pieces}, weight=${info[2].weight}
Expanded: ${this.state.expanded}
Alert[1]: ${Array.from(this.state.alert[1])}`);
          });
        });
      })
      .catch(error => {
        console.error("❌ Error loading quote:", error);
        this.setState({ isLoadingQuote: false, loadedQuoteId: null });
      });
  };


  componentDidUpdate(prevProps) {
    // Don't override accountNumber if we're loading a quote or have loaded one
    // The loadQuote function handles setting the correct account
    if (this.props.account &&
        this.props.account !== prevProps.account &&
        !this.state.isLoadingQuote &&
        !this.state.loadedQuoteId) {
      this.setState({ accountNumber: this.props.account });
    }

    // Sync accountList from props if it changed (for initial load)
    // Allow sync if: accountList changed AND (no quote loaded OR current accountList is empty)
    if (this.props.accountList !== prevProps.accountList &&
        (!this.state.loadedQuoteId || !this.state.accountList || this.state.accountList.length === 0)) {
      this.setState({ accountList: this.props.accountList });
    }
  }

  getAccountNotes = () => {
    const tempList = [];
    httpRequest
      .getAccountServiceNotes(this.state.accountNumber)
      .then((body) => {
        body.data.forEach((item) => {
          tempList.push({
            ...item,
            id: tempList.length,
            text: item.Notes || item.noteText || item.description || item.note || ""
          });
        });

        const info = this.state.info;
        info[0].AccountServiceNotes = tempList;
        this.setState({ info });
      });
  };

changePanel = (panel) => (event, isExpanded, isReset) => {
    let expanded;
    if (typeof this.state.expanded == "object") {
        expanded = this.state.expanded[0];
    } else {
        expanded = this.state.expanded;
    }

    const alert = this.state.alert[expanded];

    const alertSize = alert ? alert.size : 0;
    const firstIncompleteStep = Array.from(this.state.completed).find(i => !i[1]);
    const maxAllowedPanel = firstIncompleteStep ? firstIncompleteStep[0] : 6;

    // Prevent backward navigation from step 6 (job created/final view)
    const preventBackNav = expanded === 6 && panel < 6;

    if (isExpanded && alertSize === 0 && panel <= maxAllowedPanel && !preventBackNav) {
        this.setState({ expanded: panel }, () => {
            // Focus first focusable element in the newly opened panel
            setTimeout(() => {
                const accordionDetails = document.querySelectorAll('[class*="MuiAccordionDetails"]');
                const targetAccordion = accordionDetails[panel - 1];
                if (targetAccordion) {
                    const firstFocusable = targetAccordion.querySelector(
                        'button:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled]), select:not([tabindex="-1"]):not([disabled])'
                    );
                    firstFocusable?.focus();
                }
            }, 200);
        });
        // Only mark the step as complete if it's not step 3
        if (expanded !== 3) {
            this.state.completed.set(expanded, true);
            this.setState({ completed: this.state.completed });
        }
    }

    if (!isExpanded && isReset) {
        this.setState({ expanded: 0 });
    } else if (!isExpanded && panel === expanded) {
        // Prevent collapsing if clicking on the currently open panel
        // Only allow collapse if we're on step 0 (account/name section)
        if (panel === 0) {
            this.setState({ expanded: [panel] });
        }
        // Otherwise, do nothing - keep the current panel open
    }

    if (isExpanded && panel === expanded) {
        this.setState({ expanded: panel });
    }

    if (isExpanded && this.state.completed.get(panel) && !preventBackNav) {
        this.setState({ expanded: panel });
    }
};


  openDialog = (name) => {
    this.setState({ [name]: true });
  };

  closeDialog = (name) => {
    this.setState({ [name]: false });
  };

  updateCountTimerStatus = (val) => {
    this.setState({countTimerStatus: val });
    if(val===0){
      this.changePanel(4)(false, true, false);
      this.state.completed.set(4, false);
      this.state.completed.set(5, false);
      this.setState({ completed: this.state.completed });
    }
  };

  nextPanel = () => {
    console.log(`%c[Step ${this.state.expanded}] Next button clicked.`, 'font-weight: bold; color: blue; font-size: 14px;');
    console.log("Full Quote Data:", JSON.parse(JSON.stringify(this.state.info)));
    
    const panel = this.state.expanded + 1;
    const alert = this.state.alert[this.state.expanded];
    if (alert.size === 0) {
      this.state.completed.set(this.state.expanded, true);
      this.setState({ completed: this.state.completed });
      this.setState({ expanded: panel });
    } else {
      let alertMsg = "Please select or fill ";
      alert.forEach(i => alertMsg += i + ", ");
      this.setState({
        requiredFieldMsg: alertMsg.slice(0,-2),
      });
      this.setState({ openRequiredFieldDialog: true });
    }
  };

  setCompletedStep = (step) =>{
    const completed = this.state.completed;
    for (let i= step; i < 7; i++)
      completed.set(i, false);
    this.setState({completed,completed});
  }

  newOrderPanel = () => {
    const info = this.state.info;
    const alert = this.state.alert;
    const completed = this.state.completed;

    if (info[0]) {
      info[0].quoteId = undefined;
    }

    for (let i = 1; i < 6; i++) {
      info[i] = new Object();
    }

    for (let i = 0; i < 7; i++) {
      alert[i] = new Set();
    }

    alert[0].add("accountId");
    alert[0].add("caller");

    for (let i = 1; i < 7; i++) {
      completed.set(i, false);
    }

    this.setState({
      info: info,
      alert: alert,
      completed: completed,
      expanded: 1
    });
  };

  cleanPanelData = (key) => () => {
    const info = this.state.info;
    info[key] = new Object();
    this.setState({info,info});
  }

handleAlert = (key) => (pair) => {
  console.log("🚨 handleAlert called - key:", key, "target:", pair.target, "value:", pair.value);

  const alert = this.state.alert;
  if (pair.value) {
    alert[key].add(pair.target);
  } else {
    alert[key].delete(pair.target);
  }
  this.setState({ alert });
  
  if (alert[key].size !== 0) {
    this.state.completed.set(key, false);
    this.setState({ completed: this.state.completed });
  }
  
  // When step 0 alerts are cleared and we have a previous step, reopen to that step
  if (this.state.expanded === 0 && alert[0].size === 0) {
    const previousStep = this.state.info[0]?.previousExpandedStep;
    const targetStep = previousStep && previousStep > 0 && previousStep <= 6 ? previousStep : 1;
    
    if (!this.state.completed.get(targetStep)) {
      this.changePanel(targetStep)(false, true, false);
    }
  }

  // If step 0 gets an alert added and we're on any step > 0, close the accordion
  if(key === 0 && alert[0].size > 0 && this.state.expanded > 0){
    this.setState({expanded: 0});
    this.state.completed.set(0, false);
    this.setState({ completed: this.state.completed });
  }
};

handleChange = (key) => (pair) => {
    console.log(`handleChange: key is ${key} ---- ${pair.target} --${pair.value}`);
    if(pair.target === 'timeOption') console.log(JSON.stringify(pair.value));

    if (key === 0 && pair.target === 'accountId') {
        const newAccountNumber = pair.value;
        this.setState({accountNumber: newAccountNumber}, () => {
            this.getAccountNotes();
        });

        // Update the global account state via the passed prop
        if (this.props.updateGlobalAccount) {
            this.props.updateGlobalAccount(newAccountNumber);
        }
    }
    
    try{
      // FIXED: Only trigger accordion changes for accountId changes, NOT caller changes
      if(key===0 && pair.target === 'accountId') {
        this.changePanel(1)(false, false,true);
      }
      
      const info = this.state.info;
      info[key][pair.target] = pair.value;

      if (key === 2 && pair.target === 'packageSize' && pair.value) {
        const alert = this.state.alert;
        alert[key].delete('packageSize');
        this.setState({ info, alert });
      } else {
        this.setState({ info });
      }

      if(pair.target==='nextQuoteID'){
        const info = this.state.info;
        if(info[5].nextQuoteID !== null)
          info[0].quoteId = info[5].nextQuoteID;
        else{
          info[0].quoteId = null;
          info[0].caller = null;
          const alert = this.state.alert;
          alert[0].add("caller");
          this.setState ({alert:alert});
        }
        info[0].nextQuoteID = info[5].nextQuoteID;
      }
    }
    catch(e){console.log("handleChange exception",e)}
  };

  dynamicComponent = (structure, key) => {
    if (!structure || !structure.component) return;
    const ComponentType = structure.component;
    return <ComponentType {...structure.props} completed={this.state.completed} expanded={this.state.expanded} onChange={this.handleChange(key)} updateCounterStatus={this.updateCountTimerStatus}
            onAlert={this.handleAlert(key)} onNextPanel={this.nextPanel} duration={this.state.duration} setCompletedStep={this.setCompletedStep}
            openDialog={this.openDialog} cleanData={this.cleanPanelData(key)} isEmbedded={this.state.isEmbedded}/>;
  };

renderAccountNotesAndDropdown = () => {
  const isEmbedded = this.state.isEmbedded !== null && this.state.isEmbedded === "yes" ? true : false;

  const hasValidNotes = this.state.info[0]?.AccountServiceNotes?.some(note => note.text && note.text.trim() !== "") || false;

  return (
    <Box sx={{
      width: "100%",
      marginBottom: "8px",
      display: "flex",
      justifyContent: "space-between"
    }}>
      {isEmbedded && hasValidNotes && (
        <Box sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          marginRight: "16px"
        }}>
          <Box sx={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeeba',
            borderRadius: '4px',
            padding: '8px 15px',
            display: 'flex',
            alignItems: 'center',
            color: '#856404',
            width: '100%',
            overflow: 'hidden',
            whiteSpace: 'normal'
          }}>
            <WarningIcon style={{ marginRight: '15px', color: '#ffc107', flexShrink: 0 }} />
            <div style={{
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              {this.state.info[0].AccountServiceNotes.map((note) => {
                if (note.text && note.text.trim() !== "") {
                  return (
                    <Typography
                      key={note.id}
                      variant="body2"
                      style={{
                        marginBottom: '5px',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word'
                      }}
                    >
                      {note.text}
                    </Typography>
                  );
                }
                return null;
              })}
            </div>
          </Box>
        </Box>
      )}

      <Box sx={{ width: "400px", marginLeft: "auto" }}>
        {this.state.accountList && this.state.accountList.length > 0 ? (
          <DropdownBox
            value={this.state.accountNumber}
            choices={this.state.accountList}
            onChange={this.handleChange(0)}
            onAlert={this.handleAlert(0)}
            companyID={this.props.loginInfo?.preferences?.companyID}
            info={this.state.info}
            setCompletedStep={this.setCompletedStep}
            updateGlobalAccount={this.props.updateGlobalAccount}
            isLoadingQuote={this.state.isLoadingQuote}
            loadedQuoteId={this.state.loadedQuoteId}
          />
        ) : (
          <p>Loading account information...</p>
        )}
      </Box>
    </Box>
  );
};


  getStepSummary = (key) => {
    if (!this.state.completed.get(key) || this.state.expanded === key) return null;
    const info = this.state.info;

    switch (key) {
      case 1: {
        const pickup = info[1]?.pickUpLocation;
        const delivery = info[1]?.deliveryLocation;

        const buildAddrLine = (loc) => {
          const parts = [loc?.address, loc?.city, loc?.prov].filter(Boolean);
          return parts.join(', ');
        };

        const pickupCompany = pickup?.companyName || '';
        const deliveryCompany = delivery?.companyName || '';
        const pickupAddr = buildAddrLine(pickup);
        const deliveryAddr = buildAddrLine(delivery);

        const hasPickup = pickupCompany || pickupAddr;
        const hasDelivery = deliveryCompany || deliveryAddr;
        if (!hasPickup && !hasDelivery) return null;

        const renderLocation = (company, addr) => (
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, lineHeight: 1.3, overflow: 'hidden' }}>
            {company && (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>
                {company}
              </div>
            )}
            {addr && (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.85rem', color: '#777' }}>
                {addr}
              </div>
            )}
          </div>
        );

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0, overflow: 'hidden' }}>
            {hasPickup && renderLocation(pickupCompany, pickupAddr)}
            {hasPickup && hasDelivery && <div style={{ flexShrink: 0 }}>→</div>}
            {hasDelivery && renderLocation(deliveryCompany, deliveryAddr)}
          </div>
        );
      }
      case 2: {
        const parts = [];
        if (info[2]?.packageSize) parts.push(info[2].packageSize);
        if (info[2]?.pieces) parts.push(`${info[2].pieces} pcs`);
        if (info[2]?.weight) {
          const lbs = Number(info[2].weight);
          if (info[2]?.weightUnit === 'kg' && !Number.isNaN(lbs)) {
            const kg = lbs / 2.20462262;
            parts.push(`${Math.round(kg * 100) / 100} kg`);
          } else {
            parts.push(`${info[2].weight} lb`);
          }
        }
        return parts.length > 0 ? parts.join(' — ') : null;
      }
      case 3: {
        const selectedTags = info[3]?.selectedTagsData;
        if (selectedTags && selectedTags.length > 0) {
          return <TagsSummary tags={selectedTags} />;
        }
        return null;
      }
      case 4: {
        const timeOption = info[4]?.timeOption;
        if (timeOption?.optionText) {
          const rate = timeOption.RATE
            ? ` — ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CAD' }).format(timeOption.RATE)}`
            : '';
          return `${timeOption.optionText}${rate}`;
        }
        return null;
      }
      default:
        return null;
    }
  };

  renderAccordion = () => {
    return Object.keys(accordionStructure).map((keys) => {
      const key = parseInt(keys);
      return (
        <Accordion
          key={key}
          expanded={this.state.expanded === key}
          onChange={this.changePanel(key)}
          TransitionProps={{ timeout: 0 }}
        >
          <AccordionSummary key={key} tabIndex={-1}>
            <div style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '350px',
                minWidth: '350px',
                flexShrink: 0
              }}>
                <AccordionSummaryHead num={key} complete={this.state.completed.get(key)}/>
                <Typography color="primary">{accordionStructure[key].title}</Typography>
                {key === 4 && <CountdownTimer
                  countTimerStatus={this.state.countTimerStatus}
                  currentSection={this.state.expanded}
                  onTimerExpired={() => this.updateCountTimerStatus(0)}
                />}
              </div>
              {this.getStepSummary(key) && (
                <Typography
                  component="div"
                  variant="body2"
                  style={{
                    marginLeft: '16px',
                    color: '#555',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flex: 1,
                    minWidth: 0,
                    maxWidth: 'calc(100% - 380px)',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {this.getStepSummary(key)}
                </Typography>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails
            key={key}
            onKeyDown={(e) => {
              // Only trap tab when this is the expanded panel
              if (this.state.expanded !== key) return;

              if (e.key === 'Tab') {
                const accordionDetail = e.currentTarget;
                const focusableElements = accordionDetail.querySelectorAll(
                  'button:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled]), select:not([tabindex="-1"]):not([disabled]), textarea:not([tabindex="-1"]):not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
                );
                const focusableArray = Array.from(focusableElements);
                const firstFocusable = focusableArray[0];
                const lastFocusable = focusableArray[focusableArray.length - 1];

                if (e.shiftKey && document.activeElement === firstFocusable) {
                  e.preventDefault();
                  lastFocusable?.focus();
                } else if (!e.shiftKey && document.activeElement === lastFocusable) {
                  e.preventDefault();
                  firstFocusable?.focus();
                }
              }
            }}
          >
            {this.dynamicComponent(this.state.props[key], key)}
          </AccordionDetails>
        </Accordion>
      );
    });
  };

  render() {
    window.DEBUG_INFO = this.state.info[0];
    return (
      <Container maxWidth="100%" className="NewOrder">
        {this.state.completed.get(1) && this.state.info[0]?.quoteId && (
          <div style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            color: 'white',
            padding: '5px 10px',
            borderRadius: '5px',
            zIndex: 1000,
            fontSize: '12px'
          }}>
            Quote ID: {this.state.info[0].quoteId}
          </div>
        )}

        {this.renderAccountNotesAndDropdown()}

        {this.renderAccordion()}

        <CustomDialog
          open={this.state.openChangePickupDialog}
          onClose={() => this.closeDialog("openChangePickupDialog")}
          dialogTitle="Warning"
          dialogMessage="Note you are changing the pickup address."
          dialogAction={() => this.closeDialog("openChangePickupDialog")}
        />
        <CustomDialog
          open={this.state.openHideDialog}
          onClose={() => this.closeDialog("openHideDialog")}
          dialogTitle="Warning"
          dialogMessage="Address will be permanently removed from the list!"
          dialogAction={this.deleteLocation}
        />
        <CustomDialog
          open={this.state.openRequiredFieldDialog}
          onClose={() => this.closeDialog("openRequiredFieldDialog")}
          dialogTitle="Warning"
          dialogMessage={this.state.requiredFieldMsg}
        />
        <footer>
          <Copyright/>
        </footer>
      </Container>
    );
  }
}

export default withParams(NewOrder);